import {GridColDef} from '@mui/x-data-grid';
import {get, toString} from 'lodash';
import Status from '../../../../ui/status/Status';
import {BASE_TITLES} from '../../../../shared/constants';
import {ServiceRequestShortDto} from '../../../../global/api';
import {TypeServiceRequestStatusCode} from '../../../../shared/types/serviceRequest.types';

export const columns: GridColDef<ServiceRequestShortDto>[] = [
  {
    field: 'id',
    headerName: BASE_TITLES.id.base,
  },
  {
    field: 'contract',
    headerName: BASE_TITLES.contract.base,
    renderCell: ({row}) => row?.contractNumber || '-',
  },
  {
    field: 'address',
    headerName: BASE_TITLES.address.base,
    renderCell: ({row}) => row.fullAddress || '-',
  },
  {
    field: 'workers',
    headerName: BASE_TITLES.workers.base,
    renderCell: ({row}) => toString(get(row, 'workers', '-')),
  },
  {
    field: 'taskLocation',
    headerName: BASE_TITLES.taskLocation.base,
    renderCell: ({row}) => row.workLocation || '-',
  },
  {
    field: 'price',
    headerName: BASE_TITLES.price.base,
    renderCell: () => '-',
  },
  {
    field: 'status',
    headerName: BASE_TITLES.status.base,
    minWidth: 172,
    renderCell: ({row}) => (
      <Status
        border={row.statusCode === 'CREATED'}
        sx={{fontSize: '12px'}}
        variant="subtitle2"
        entity="serviceRequest"
        code={row.statusCode as TypeServiceRequestStatusCode}
      />
    ),
  },
];
